import { QueryPayload } from "@repo/api/clients/policies.api";

export const policiesKeys = {
  all: ["policies"] as const,
  permissions: () => [...policiesKeys.all, "permissions"] as const,
  policyList: (filters: {
    searchValue: string;
    selectedFilters: Record<string, unknown>;
  }) => [...policiesKeys.all, "policyList", JSON.stringify(filters)] as const,
  policyFindingsList: () =>
    [...policiesKeys.all, "policyFindingsList"] as const,
  executeQuery: (payload?: QueryPayload) =>
    [...policiesKeys.all, "executeQuery", JSON.stringify(payload)] as const,
  deletePolicy: (policyId: string) =>
    [...policiesKeys.all, "deletePolicy", policyId] as const,
  policiesFilters: () => [...policiesKeys.all, "policiesFilters"] as const,
  queryPolicies: () => [...policiesKeys.all, "queryPolicies"] as const,
  querySuggestion: (text: string) =>
    [...policiesKeys.all, "querySuggestion", text] as const,
  policyById: (policyId: string) =>
    [...policiesKeys.all, "policyById", policyId] as const,
  inventorySummaryData: (assetId: string) =>
    [...policiesKeys.all, "inventorySummaryData", assetId] as const,
  findingsTabData: (assetId: string) =>
    [...policiesKeys.all, "findingsTabData", assetId] as const,
  inventoryTimelineData: (assetId: string) =>
    [...policiesKeys.all, "inventoryTimelineData", assetId] as const,
  ownerFiltersValues: () =>
    [...policiesKeys.all, "ownerFiltersValues"] as const,
  assignOwnerFiltersList: () =>
    [...policiesKeys.all, "assignOwnerFiltersList"] as const,
  ownersList: () => [...policiesKeys.all, "ownersList"] as const,
  previouslyAssignedOwners: (assetId: string) =>
    [...policiesKeys.all, "previouslyAssignedOwners", assetId] as const,
  policiesFindingsFilter: () =>
    [...policiesKeys.all, "policiesFindingsFilter"] as const,
  bulkTicketCreation: () =>
    [...policiesKeys.all, "bulkTicketCreation"] as const,
  accessMapData: (id: string) =>
    [...policiesKeys.all, "accessMapData", id] as const,
  policyTags: () => [...policiesKeys.all, "policyTags"] as const,
  saveViewList: () => [...policiesKeys.all, "saveViewList"] as const,
};
